import { render } from "./quickLinks.vue?vue&type=template&id=e77d674c&scoped=true"
import script from "./quickLinks.vue?vue&type=script&lang=js"
export * from "./quickLinks.vue?vue&type=script&lang=js"

import "./quickLinks.vue?vue&type=style&index=0&id=e77d674c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77d674c"]])

export default __exports__